import { render, staticRenderFns } from "./activity-approval.vue?vue&type=template&id=194fc686"
import script from "./activity-approval.vue?vue&type=script&lang=js"
export * from "./activity-approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports